import { AttestationType } from 'app/constants/attestationType'

export const getAttestationType = (type) => {
  let activityType = AttestationType.NONE

  switch (type) {
    case 1:
      activityType = AttestationType.DRIVING
      break
    case 2:
      activityType = AttestationType.WORK
      break
    case 3:
      activityType = AttestationType.AVAILABILITY
      break
    case 4:
      activityType = AttestationType.REST
      break
    case 5:
      activityType = AttestationType.TIMEOFF
      break
    case 6:
      activityType = AttestationType.SICKLEAVE
      break
  }

  return activityType
}

export const getAttestationTypeNumber = (type: AttestationType) => {
  let activityType = 0

  switch (type) {
    case AttestationType.DRIVING:
      activityType = 1
      break
    case AttestationType.WORK:
      activityType = 2
      break
    case AttestationType.AVAILABILITY:
      activityType = 3
      break
    case AttestationType.REST:
      activityType = 4
      break
    case AttestationType.TIMEOFF:
      activityType = 5
      break
    case AttestationType.SICKLEAVE:
      activityType = 6
      break
  }

  return activityType
}
